import { createHashRouter } from "react-router-dom";
import App from "../App";
import Home from "../pages/Home";
import { Routes } from "./routes";
import GadgetDetails from "../pages/GadgetDetails";
import { LearnAboutPlatform } from "../pages/LearnAboutPlatform";
import { LearAboutRecipe } from "../pages/LearnAboutRecipe";
import { AboutGadgetBuilder } from "../pages/AboutGadgetBuilder";
import { Status } from "../pages/UserRegistration/Status";
import ErrorPage from "../pages/ErrorPage";
import { Downloads } from "../components/Downloads";
import { HelpSupport } from "../components/HelpSupport";
import { ComingSoon } from "../components/ComingSoon";
import { CaseStudyShimadzu } from "../components/CaseStudyShimadzu";
import { CaseStudyPrism } from "../components/CaseStudyPrism";
import ChangeLog from "../components/ChangeLog";

export const router = createHashRouter(
  [
    {
      path: "/",
      element: <App/>,
      children: [
        {
          index: true,
          element: <Home />,
        },
        {
          path: Routes.HOME,
          element: <Home />,
        },
        {
          path: Routes.GADGET_DETAILS,
          element: <GadgetDetails />,
        },
        {
          path: Routes.ABOUT_PLATFORM,
          element: <LearnAboutPlatform />
        },
        {
          path: Routes.ABOUT_RECIPE,
          element: <LearAboutRecipe />
        },
        {
          path: Routes.ABOUT_GADGET_BUILDER,
          element: <AboutGadgetBuilder />
        },
        {
          path: Routes.USER_REGISTRATION_STATUS,
          element: <Status />
        },
        {
          path: Routes.DOWNLOADS,
          element: <Downloads />
        },
        {
          path: Routes.HELP_SUPPORT,
          element: <HelpSupport />
        },
        {
          path: Routes.KNOWLEDGE_BASE,
          element: <ComingSoon />
        },
        {
          path: Routes.CHANGELOG,
          element: <ChangeLog />
        },
        {
          path: Routes.CASE_STUDIES_SHIMADZU,
          element: <CaseStudyShimadzu />
        },
        {
          path: Routes.CASE_STUDIES_PRISM,
          element: <CaseStudyPrism />
        }
      ],
      errorElement: <ErrorPage />
    }
  ]
);